<div [id]="quillId" class="w100 quill-editor" [hidden]="!editor"> </div>

<textarea id="quill-editor-area" class="full" [hidden]="editor"></textarea>